module.exports = __webpack_public_path__ + "img/denuncia_bg.fc3a2c1d.jpg";